import { provideStore } from '@ngrx/store';

import { tagsLabelsReducer } from '@core/store/admin/tags-labels/tags-labels.reducer';
import { initialTagsLabelsState } from '@core/store/admin/tags-labels/tags-labels.state';
import { authReducer, initialAuthState } from '@core/store/auth/auth.reducer';
import { commentsConfigReducer } from '@core/store/comments-config/comments-config.reducer';
import { initialCommentsConfigState } from '@core/store/comments-config/comments-config.state';
import {
  dataVisualizationPopupReducer,
  initialDataVisualizationPopupState
} from '@core/store/data-visualization-popup/data-visualization-popup.reducers';
import {
  dataVisualizationReducer,
  initialDataVisualizationState
} from '@core/store/data-visualization/data-visualization.reducers';
import {
  dataspaceReducer,
  initialDataspaceState
} from '@core/store/dataspace/dataspace.reducers';
import { featureFlagsReducer } from '@core/store/feature-flags/feature-flags.reducer';
import { initialFeatureFlagsState } from '@core/store/feature-flags/feature-flags.state';
import { optimizationHistoryReducer } from '@core/store/optimization-history/optimization-history.reducer';
import { initialOptimizationHistoryState } from '@core/store/optimization-history/optimization-history.state';
import { planEditReducer } from '@core/store/plan-edit/plan-edit.reducer';
import { initialPlanEditState } from '@core/store/plan-edit/plan-edit.state';
import { planFindingsReducer } from '@core/store/plan-findings/plan-findings.reducer';
import { initialPlanFindingsState } from '@core/store/plan-findings/plan-findings.state';
import { initialPlanState, planReducer } from '@core/store/plan/plan.reducers';
import { profileReducer } from '@core/store/profile/profile.reducer';
import { initialProfileState } from '@core/store/profile/profile.state';
import { userPreferencesReducer } from '@core/store/user-preferences/user-preferences.reducer';
import { initialUserPreferencesState } from '@core/store/user-preferences/user-preferences.state';

export const storeConfig = provideStore({
  auth: authReducer,
  dataspace: dataspaceReducer,
  featureFlags: featureFlagsReducer,
  plan: planReducer,
  planFindings: planFindingsReducer,
  planEdit: planEditReducer,
  dataVisualizationPopup: dataVisualizationPopupReducer,
  dataVisualization: dataVisualizationReducer,
  'tags-labels': tagsLabelsReducer,
  'comments-config': commentsConfigReducer,
  userPreferences: userPreferencesReducer,
  profile: profileReducer,
  optimizationHistory: optimizationHistoryReducer
});

export const initialMockState = {
  auth: initialAuthState,
  dataspace: initialDataspaceState,
  featureFlags: initialFeatureFlagsState,
  plan: initialPlanState,
  planFindings: initialPlanFindingsState,
  planEdit: initialPlanEditState,
  dataVisualizationPopup: initialDataVisualizationPopupState,
  dataVisualization: initialDataVisualizationState,
  'tags-labels': initialTagsLabelsState,
  'comments-config': initialCommentsConfigState,
  userPreferences: initialUserPreferencesState,
  profile: initialProfileState,
  optimizationHistory: initialOptimizationHistoryState
};
